<template>
  <div class="login-container">
    <h1>User Login</h1>
    <form @submit.prevent="login" class="login-form">
      <input type="text" v-model="email" placeholder="Email" required class="input-field" />
      <input type="password" v-model="password" placeholder="Password" required class="input-field" />
      <button type="submit" class="submit-button">Login</button>
      <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>

    </form>
  </div>
</template>

<script>
import authService from '@/services/authService'; // authService'ı içe aktar


export default {
  name: 'UserLogin',
  data() {
    return {
      username: '',
      password: ''
    };
  },

  methods: {
    async login() {
      try {
        const response = await authService.login(this.email, this.password);
        console.log(response);
        if (response.success) {
          localStorage.setItem('user', JSON.stringify(response));

          this.$router.push({ name: 'PhoneDashboard' });
        } else {
          // Hata durumunda mesaj göster
          this.errorMessage = response.message || 'Giriş başarısız. Lütfen tekrar deneyin.';
        }
      } catch (error) {
        // Hata durumunda mesaj göster
        this.errorMessage = 'Bir hata oluştu. Lütfen tekrar deneyin.';
      }
    },
    async logout() {
  try {
    // Kullanıcı bilgilerini yerel depolamadan sil
    localStorage.removeItem('user');
    await authService.logout();

    // Kullanıcıyı giriş sayfasına yönlendir
    this.$router.push({ name: 'UserLogin' }); // Giriş sayfasının adı
  } catch (error) {
    // Hata durumunda mesaj göster
    this.errorMessage = 'Bir hata oluştu. Lütfen tekrar deneyin.';
  }
}
 
  },
  
  created() {
    // LocalStorage'da geçerli bir token kontrolü
    const user = localStorage.getItem('user');
    console.log('User:', user); //
    if (user) {
      // Token yoksa login sayfasına yönlendir
      this.$router.push({ name: 'PhoneDashboard' });
    }
  },
};
</script>

<style scoped>
.login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #f0f0f0;
}

.login-form {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.input-field {
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.submit-button {
  width: 100%;
  padding: 10px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.submit-button:hover {
  background-color: #0056b3;
}
</style>
